import { render, staticRenderFns } from "./LockerPeriods.vue?vue&type=template&id=aa35f492&scoped=true"
import script from "./LockerPeriods.vue?vue&type=script&lang=js"
export * from "./LockerPeriods.vue?vue&type=script&lang=js"
import style0 from "./LockerPeriods.vue?vue&type=style&index=0&id=aa35f492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35f492",
  null
  
)

export default component.exports